/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { CookieService } from 'ngx-cookie';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output,  ViewChild, ViewChildren } from '@angular/core';
import { RestService } from '../shared/rest.service';
import { ApiService } from '../itinerary/shared/api.service';
import { ItineraryService } from '../shared/itinerary.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SortByDestinationPipe } from '../shared/sortByDestination.pipe';
import { UserService } from '../pages/com.usblick.common/auth/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NrPrepaymentModalComponent } from '../shared/nr-prepayment-modal/nr-prepayment-modal.component';
import { NrBlockModalComponent } from '../shared/nr-block-modal/nr-block-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { FidelityService } from '../fidelity/fidelity.service';
import * as moment from 'moment';
import { ModalPostBookingComponent } from '../shared/modal-post-booking/modal-post-booking.component';
import { MaterialModalAlertComponent } from '../shared/material-modal-alert/material-modal-alert.component';
import { VerificationModalComponent } from '../shared/modals/verification-modal/verification-modal.component';
import { setting } from '../../../setting';
import { Observable, Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions } from 'app/core/profiles/profiles.selectors';
import { HttpErrorResponse } from '@angular/common/http';
import { FlightModalComponent } from 'app/shared/flight-modal/flight-modal.component';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { ConnectingModalComponent } from 'app/shared/modals/connecting-modal/connecting-modal.component';
import { NotificationService } from 'app/shared/notifications/notification.service';
moment.locale('es');
@Component({
  selector: 'usb-itinerary-detail',
  templateUrl: './itinerary-detail.component.html',
  styleUrls: ['./itinerary-detail.component.scss'],
  providers: [SortByDestinationPipe, DatePipe],
})

export class ItineraryDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('card') cardItinerary: any;
  @ViewChild('componentFlight')
  componentFlight!: FlightModalComponent;
  @Input() appLoading = true;
  @Input() itemsSync: any[] = [];
  @Input() itineraryId: any;
  @Input() results = false;
  @Output() parcialBlickoinsUpdated = new EventEmitter<number>();
  @Output() shouldContinueEvent = new EventEmitter<boolean>();
  partialReservationArray: any;
  status!: string;
  id!: number;
  idReservation!: number;
  idConfirmation!: number;
  totalNetPriceBookingFreeTax!: number;
  totalTaxNightsPriceTotal!: number;
  itinerary: any;
  screen!: string;
  goTo = '';
  itemsArray!: any[];
  destinationsArray: any;
  empty: boolean;
  _cookieClient: any = undefined;
  isUpdate = false;
  reservations: any;
  activeButtonPartialReserve = false;
  isActivePartialReserve = false;
  qtyItemsToPartial = 0;
  modifications = false;
  priceAgent = 0;
  public getClientsSettingAppBooking: any;
  public parcialBlickoins = 0;
  itineraryLoaded = false;
  public showTextChangeDetailsProducts = false;
  public changePriceFromReserve = true;
  public itemChangeTwoProduct = false;
  showBoton = true;
  showPartialContainer = false;
  partialBlickoinsAfterInit = 0;
  public taxes: any[] = [];
  public taxSum = 0;
  public dataAux: any;
  allowed = ['AV360', 'AV200'];
  headerStyle: any;
  currentDate: Date = new Date();
  updatedAt: any;
  buttonColorActive = '';
  buttonTextActive = '';
  payloadSearchTransportFly: any;
  formTransportsFly: any;
  partialSelectedItems = new Set<number>();
    private destroy$ = new Subject<void>();
  private previousItemsLength: number | null = null;
  public statusArray = {
    update: null,
    available: false,
    samePrice: false,
    modifications: false,
    verified: false,
    reserved: false,
  };
  paymentConditions: any;
  paymentAgencyActive: any;
  permissions$!: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

  totalNetPriceBooking!: number;
  netPriceBookingFreeTax: any;
  netPriceBooking: any;
  currencies: any[] = [];
  currencyAgency: any;
  dateFormatCache = new Map();
  backgroundSelect: any;
  actionComponentFlight = '';
  openModalFly = false;
  itineraryItemsReserve: any[] = [];
  taxExcluded = 0;
  public taxesSummable: { description?: string; amount?: number; included?: boolean }[] = [];
  public taxesNotSummable: { description?: string; amount?: number; currency?: string }[] = [];


  itinerarySubcription!: Subscription;

  constructor(
    public restService: RestService,
    private apiService: ApiService,
    public itineraryService: ItineraryService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private destinationPipe: SortByDestinationPipe,
    private _cookieService: CookieService,
    public userService: UserService,
    private ngxSpinner: NgxSpinnerService,
    public dialog: MatDialog,
    public fidelityService: FidelityService,
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {

    this.partialReservationArray = [];
    this.empty = false;



  }
  ngOnDestroy(): void {
    if(this.itinerarySubcription) {
      this.itinerarySubcription.unsubscribe();
    }
  }
  ngOnInit() {
     this.currencies = this.userService.currenciesExchange;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    // selectedAgency puede no estar listo todavía para un guest recién creado
    // (agencyShow() del guest bootstrap es async) cuando este componente se
    // monta oculto desde yourtrip-summary — no reventar, solo dejar sin
    // moneda de agencia resuelta.
    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency?.currency);

    if(!this.currencyAgency && !this.userService._isGuest) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.headerStyle = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
    const bookingFlow_sidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.permissions$ = this.store.select(selectPermissions);
    // Despacha las acciones para cargar roles y permisos
    // this.store.dispatch({ type: '[Auth] Load Permissions' });

    this.permissions$.subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });


    this.results = false;
    this.status = 'false';
    this.setItinerary();
    this.getItinerary('false');
    // this.getItinerary("false");
    this.getDetailPricesCards();
    this.userService.activeGlobalFee = false;
    this.verificarCondiciones();
    this.destinationsArray;


      this.getPaymentConditions(selectedAgency);
  }


        getPaymentConditions(agency: any) {
          this.restService.doGet('app', 'agencyPaymentCondition/list?').subscribe({
            next: (response: any) => {
              if(response) {
                this.paymentConditions = response;
                this.availablePaymentConditions(this.paymentConditions, agency);
              }
            },
            error: (error: HttpErrorResponse) => {
            }
          });
        }

  private availablePaymentConditions(dataPaymentCondition: any, agency: any) {
        const payAgencyActive = dataPaymentCondition.find(c => c.id === agency?.pay_mode);
        this.paymentAgencyActive = payAgencyActive;
      }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      // Utiliza el nombre del permiso como clave
      map[permission.name] = permission;
    });
    return map;
  }

    verificarCondiciones() {
      if (this.itinerary) {
        this.showBoton = (this.itinerary.items.length > 1 &&
                          this.itinerary.status_id != 3 &&
                          this.itinerary.status_id != 4 &&
                          this.itinerary.status_id != 5 &&
                          this.itinerary.status_id != 6 &&
                          this.activeButtonPartialReserve);
      }
    }

    getSubscriptionLoading(): void {
      this.itineraryService.loading$.subscribe((res: boolean) => {
        if(res === false) {
          this.appLoading = false;
        }
      });
    }


    ngAfterViewInit() {
      this.verificarCondiciones();
      this.showPartialContainer = false;

    }

    controlShow() {
      this.showPartialContainer = !this.showPartialContainer;
    }


  _reloadItinerary() {
    this.getItinerary('false');

     window.location.reload();
    // this.userService.activeGlobalFee = false;
  }
  // ✅ Flag para evitar llamadas simultáneas
    private isLoadingPrices = false;
    private priceTimeout: any = null;
    private lastPriceId = -1;
    private _priceSubscription!: Subscription;

    getDetailPricesCards() {
        if (this.id > -1) {
            // ✅ Evitar llamadas si ya está en ejecución
            if (this.isLoadingPrices) {
                return;
            }

            // ✅ Evitar llamadas duplicadas con el mismo ID
            if (this.lastPriceId === this.id) {
                return;
            }
            this.lastPriceId = this.id;

            // ✅ Limpiar timeout anterior
            if (this.priceTimeout) {
                clearTimeout(this.priceTimeout);
                this.priceTimeout = null;
            }

            this.isLoadingPrices = true;
            const url = 'products/getPriceAgent/' + this.id;

            // ✅ Guardar referencia a la suscripción
            if (this._priceSubscription && !this._priceSubscription.closed) {
                this._priceSubscription.unsubscribe();
            }

            this._priceSubscription = this.restService.doGet('app', url).subscribe({
                next: (data: any) => {
                    this.isLoadingPrices = false;

                    if (Object.keys(data).length > 0) {

                        this.userService.itinerayDetailFee = data;
                        this.dataAux = data.products;

                        this.dataTax(this.dataAux);

                        if(this.dataAux) {
                          this.dataTaxExcluded(this.dataAux);


                          if(this.taxExcluded > 0) {
                            this.taxSum = this.taxSum + this.taxExcluded;
                          }

                        }

                        this.netPriceBookingFreeTax = this.sumPropertyValues(data.products, 'netPriceBookingFreeTax') ;

                        if(this.taxExcluded > 0) {
                            this.netPriceBookingFreeTax = this.netPriceBookingFreeTax + this.taxExcluded;
                        }

                        this.netPriceBooking = this.sumPropertyValues(data.products, 'netPriceBooking');

                        this.userService.priceGeneralData = data.totalnetPriceBookingFreeTax;

                        if (this.screen == 'addFee') {
                            this.userService.sendPrices$(data);
                        } else {
                            this.userService.sendPrices$(data);
                        }
                    }

                    // ✅ Resetear el cache después de un tiempo
                    this.priceTimeout = setTimeout(() => {
                        this.lastPriceId = -1;
                    }, 5000);
                },
                error: (error: HttpErrorResponse) => {
                    this.isLoadingPrices = false;
                }
            });
        }
    }

    // ✅ Método para forzar recarga
    forceGetDetailPricesCards() {
        this.lastPriceId = -1;
        this.getDetailPricesCards();
    }

  private dataTax(data: any) {
    // Impuestos no incluidos que sí se pudieron convertir a la moneda de la agencia
    // (forman parte de taxSum) y los que no se pudieron convertir por no soportarse
    // su moneda (quedan afuera del total pero igual se pagan en destino).
    this.taxesSummable = [];
    this.taxesNotSummable = [];

    if (data && data.length > 0) {
      // Recorre cada producto en los datos
      data.forEach((product) => {
        if(product.category_id === 1) {
           // Verifica si existe un ítem y si es un string
          if (product.item && typeof product.item === 'string') {
            // Convierte el ítem en un objeto JSON
            const item = JSON.parse(product.item);

            // Verifica si hay taxes en el ítem
            if (item.taxes && Array.isArray(item.taxes)) {
              // Recorre cada impuesto en las taxes
              item.taxes.forEach((tax) => {

                // Verifica si 'included' es un booleano verdadero
                if (typeof tax.included === 'boolean' && tax.included) {

                  const taxCurrency = this.currencies.find(c => c.code === tax.currency);

                  if (taxCurrency) {
                    const taxBase = tax.amount / taxCurrency.rate;
                    const taxCurrencyAgency = taxBase * this.currencyAgency?.rate;

                    this.taxSum += taxCurrencyAgency;

                    this.taxesSummable.push({
                      description: tax.description,
                      amount: taxCurrencyAgency,
                      included: false
                    });
                  } else {
                    // Moneda del impuesto no soportada: no se puede convertir ni sumar
                    // al total, pero igual corresponde pagarlo en destino.
                    this.taxesNotSummable.push({
                      description: tax.description,
                      amount: tax.amount,
                      currency: tax.currency
                    });
                  }
                }
              });
            }
          }
        }

      });
    }
    // Formatea el resultado con dos decimales
    // this.taxSum = parseFloat(this.taxSum.toFixed(2));

    this.taxSum = parseFloat(this.taxSum.toFixed(2));
  }

  private dataTaxExcluded(data: any) {
    // Impuestos no incluidos que sí se pudieron convertir a la moneda de la agencia
    // (forman parte de taxSum) y los que no se pudieron convertir por no soportarse
    // su moneda (quedan afuera del total pero igual se pagan en destino).
    this.taxesSummable = [];
    this.taxesNotSummable = [];

    if (data && data.length > 0) {
      // Recorre cada producto en los datos
      data.forEach((product) => {
        if(product.category_id === 1) {
           // Verifica si existe un ítem y si es un string
          if (product.item && typeof product.item === 'string') {
            // Convierte el ítem en un objeto JSON
            const item = JSON.parse(product.item);

            // Verifica si hay taxes en el ítem
            if (item.taxes && Array.isArray(item.taxes)) {
              // Recorre cada impuesto en las taxes
              item.taxes.forEach((tax) => {
                // Verifica si 'included' es un booleano verdadero
                if (typeof tax.included === 'boolean' && !tax.included) {

                  const taxCurrency = this.currencies.find(c => c.code === tax.currency);

                  if (taxCurrency) {
                    const taxBase = tax.amount / taxCurrency.rate;
                    const taxCurrencyAgency = taxBase * this.currencyAgency?.rate;

                    this.taxExcluded += taxCurrencyAgency;

                    this.taxesSummable.push({
                      description: tax.description,
                      amount: taxCurrencyAgency,
                      included: false
                    });
                  } else {
                    // Moneda del impuesto no soportada: no se puede convertir ni sumar
                    // al total, pero igual corresponde pagarlo en destino.
                    this.taxesNotSummable.push({
                      description: tax.description,
                      amount: tax.amount,
                      currency: tax.currency
                    });
                  }
                }
              });
            }
          }
        }

      });
    }
    // Formatea el resultado con dos decimales
    // this.taxSum = parseFloat(this.taxSum.toFixed(2));

    this.taxExcluded = parseFloat(this.taxExcluded.toFixed(2));
  }

  sumPropertyValues(data: any[], propertyName: string): number {
    let totalValue = 0;
    data.reduce((total, item, index) => {
      const itemParse = JSON.parse(item.item);
      if(item.status_id !== 4 && item.status_id !== 5) {
        // Asegurarse de que el objeto tenga la propiedad deseada
        if (item[propertyName]) {

            const itemBaseCurrency = this.currencies.find(c => c.code === item.currency);
            const itemBasePrice = item[propertyName] / itemBaseCurrency.rate;
            totalValue += itemParse?.converted_amounts ? itemParse?.converted_amounts[propertyName] : (itemBasePrice * this.currencyAgency.rate);
          }
        }
        return total;
    }, 0);

    totalValue = totalValue ;

    return totalValue;
  }

  getDetailPricesCardsReservation() {
    const url = 'reservations/getPriceAgent/' + this.idReservation;

    this.restService.doGet('app', url).subscribe(
      (data: any) => {
        this.userService.itinerayDetailFee = data;
        this.userService.itinerayDetailFee = data;
      },
      (error) => {
      }
    );
  }

  _modifications() {

    this.updateCards(false, 'sync');
  }

  resetPartial() {
    this.itineraryService.updateRemoveItineraryPartial(this.id);
  }

  getReservations() {}

  findReservedProduct(item) {
    if (this.reservations) {
      if (this.reservations != 'Data Not Found') {
        const dato = this.reservations.find((element) => item.item.title == element.resultReserve.title);
        if (dato) {
          return dato;
        }
      }
    }
  }

    /**
     * Establece el itinerario actual, ya sea desde el servicio `userService` o llamando al servicio `serviceItinerary` para obtenerlo.
     * Si no hay un itinerario activo, se realiza una suscripción para obtener el itinerario.
     */
    setItinerary() {
      this.itinerary = this.userService.itineraryActive[0];
      this.itinerarySubcription = this.itineraryService.getItinerary$().pipe(
        map((data: any) => ({
          fullData: data?.[0],
          id: data?.[0]?.id,
          itemsLength: data?.[0]?.items?.length ?? 0,
          flightsLength: data?.[0]?.flights?.length ?? 0
        })),
        distinctUntilChanged((prev, curr) =>
          prev.id === curr.id &&
          prev.itemsLength === curr.itemsLength &&
          prev.flightsLength === curr.flightsLength
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((response) => {
        if (response.fullData) {
          this.itinerary = response.fullData;
          this.getItinerary('false');

          this.previousItemsLength = response.itemsLength;
        }
      });

    }


  getItinerary(isSinc) {
    this.route.queryParams.subscribe((params) => {
      this.itineraryLoaded = false;

      if(this.itineraryService.itinerary?.id) {
        if(this.itineraryService.itinerary?.id !== Number.parseInt(params['id'])) {

          this.id = this.itineraryService.itinerary?.id;

              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                  id: this.itineraryService.itinerary?.id,
                  stat: params['stat'] || false,
                  screen: params['screen'] || 'detail',
                  goTo: params['goTo'] || 'reserve'
                },
                queryParamsHandling: 'merge', // Mantiene otros parámetros
                replaceUrl: true // Reemplaza en el historial (sin nueva entrada)
              });
      } else {
        this.id = Number.parseInt(params['id']);
      }

      } else {
        this.id = Number.parseInt(params['id']);
      }

      // this.status = params["stat"];
      this.screen = params['screen'];
      if (params['goTo']) {
        this.goTo = params['goTo'];
      }


      this.idReservation = Number.parseInt(params['reservationId']);

      if (this.id) {


        const url = `itineraries?active_agent_id=${this.userService._agentID}&active_agency_id=${this.userService._agencyID}&active=1`;

        this.apiService.doGet('itineraries/' + this.id).subscribe({
          next: (response: any) => {
            this.itineraryService.captureVolatileItemFields(this.itinerary?.items);
            this.itinerary = response;
            this.userService.items = response.items;
            this.userService.itineraryActive[0] = response;
            const syncProduct = this.userService.items.map(c => c.syncProduct);
            // Filtrar elementos undefined del array
            const filteredSyncProduct = syncProduct.filter(Boolean);

            const existsAlerMessage = filteredSyncProduct.some(c => c.alert === true);



            if (filteredSyncProduct.length > 2) {
              const productAlertMessages = filteredSyncProduct.filter(c => c.alert === true);

              if (productAlertMessages.length > 0 && filteredSyncProduct.length === 2) {

                this.itemChangeTwoProduct = true;
              }
            }

            if (this.screen == 'detail' || this.screen == 'addFee') {
              this.getDetailPricesCards();
              this.appLoading = false;
              this.getSubscriptionLoading();
            }
            if (response.items.length > 0) {

              if ((this.screen == 'detail') && (isSinc =='false')) {
                // console.log("resetPartial", isSinc);
                this.resetPartial();
                //valido si hay mas de 1 items en save para activar el boton de partial
                let index = 0;
                response.items.forEach((item) => {
                  if (item.status_id == 1) {
                    index++;
                  }
                });
                if (index > 1) {
                  this.activeButtonPartialReserve = true;
                }
              }
              this.updateItinerary();
              this.itineraryLoaded = true;
              this.appLoading = false;
              this.getSubscriptionLoading();

              //     this.updateCards();
            } else {
              this.appLoading = false;
              this.getSubscriptionLoading();
              this.empty = true;
              this.router.navigateByUrl('/home');
            }
          },
          error: (error: HttpErrorResponse) => {
            this.appLoading = false;
            this.getSubscriptionLoading();
          }
        });
      }
    });
  }

  emitShouldContinue(shouldContinue: boolean) {
    // console.log(shouldContinue)
    this.shouldContinueEvent.emit(shouldContinue);
  }

  public async updateCards(reserve, action?: string) {
    // Tu código actual aquí
    // Agregar una Promesa para indicar que la función ha terminado
    return new Promise<void>((resolve) => {
      this.getItinerary(false);
      setTimeout(() => {
        this.modifications = false;
        this.syncProduct(reserve, action);
        resolve(); // Resolvemos la Promesa para indicar que ha terminado
      }, 1000);
    });
  }

  /// modal loading
  openModalSyncProduct(data: any, i: any, action?: string) {
    const typeModal = action === 'sync' ? VerificationModalComponent : ConnectingModalComponent;
    const dialogRef = this.dialog.open(typeModal , {
      width: '500px',
      id: 'loadModal' + i,
      data: {data, action},
      disableClose: true,
      panelClass: 'no-padding-dialog'
    });
  }

  /**
   * Este metodo ejecuta la sincronización del producto, previo a la reserva.
   * Se cambio la lógica, para enviar el payload de la sincronización a octopus. Sin tener de por medio a booking-api.
   * La estructura del payload de booking-api que enviaba a octopus, ahora lo maneja booking-app.
   * @param reserve
   */
  async syncProduct(reserve, action?: string) {
    this.itemsArray = [];
    const groupedByBookingCode: { [bookingCode: string]: any[] } = {};
    const payloadSync =
      {
       products:[],
      };

    let itemUpdated;
    let payload: any;
    let booleanSync: boolean;
    let i = 0;
    const qtyUp_ = 0;
    this.itemsSync;
    const codeStatus = false;


    // if(this.itemsSync.length < 1) {
      if (this.partialSelectedItems.size > 0) {
          // Filtrar solo los items cuyo product_id esté en el Set
          this.itemsSync = this.itinerary.items.filter(item =>
            this.partialSelectedItems.has(item.id)
          );
        } else {
          // Si no hay elementos seleccionados, filtrar por status_id == 1
          this.itemsSync = this.itinerary.items.filter(item =>
            item.status_id === 1 && item.source === 'Web'
          );
        }
    // }

    for (const item of this.itemsSync) {
      await this.openModalSyncProduct(item, i++, action);
    }

    const items = action === 'reserve' ? this.itineraryItemsReserve : this.itemsSync;

    items.forEach(item => {
      switch(item.category_id) {
        //case 1 || 6 (anteriormente)
        case 1:
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.id = item.id;

              if(product?.others?.hotels?.roomConfiguration && product?.others?.hotels?.roomConfiguration.length > 0) {

                product?.others?.hotels?.roomConfiguration.forEach((room: any, index: number) => {

                  if(room.children && room.children.length > 0) {
                    // Verificar si algún child tiene id
                    const hasId = room.children.some(child => child.id !== undefined);

                    if(hasId) {
                      // Mapear solo las edades
                      room.children = room.children.map(child => child.age);
                    }
                  }
                });
              };
            });
          break;

          case 2:
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.id = item.id;
              product.providerId = item.providerId;
              product.ratecode = item.RatePlanCode;
            });

      break;

      case 5: //Vuelo
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.id = item.id;
            });
      break;

        case 6: //Experiencia
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.market = 2;
              product.id = item.id;
            });
          break;
        case 9: //tickets
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.market = 1;
              product.id = item.id;
            });
          break;
        case 8:
          item.payloadSync.id = item.id;
          if(item.firstWay === 1 || item.totalWay === 1) {
            item.payloadSync.entry = true;
          }
          if(item.firstWay === 2) {
            item.payloadSync.entry = false;
          }
          payloadSync.products.push(item.payloadSync);
        // }
        break;
        case 10:
          payloadSync.products.push(...item.payloadUpdate.products);
            item.payloadUpdate.products.forEach(product => {
              product.id = item.id;
            });
          break;
      }
    });

    if (items.length > 0) {
      // console.log("syncProducts");
      // console.log(JSON.stringify(this.itemsSync));
      try {
        const data = await this.restService.doPost('app', 'syncProducts', payloadSync).toPromise();
        setTimeout(() => {
          this.dialog.closeAll();
          if(data['mens'] &&
            Array.isArray(data['mens'])) {

              this.getItinerary('true');
              if (reserve) {

                if (
                      data['mens'] &&
                      data['mens'].length > 0 &&
                      data['mens'].every((item: string) => this.allowed.includes(item))
                    ){

                    if(this.results) {
                      this.emitShouldContinue(false);
                    }

                    if(!this.results) {
                      if (this.isActivePartialReserve && this.qtyItemsToPartial > 0){
                        this.partialReserve();

                      } else {
                        this.reserveAll();
                      }
                    }

                  // console.log('data verif ->', data.verif);

                }else {
                  if(!this.results) {
                    this.resetPartial();
                    this.changePriceFromReserve = true;
                  }
                  if(this.results) {
                    if( data['mens'] && !data['success']) {

                    }
                      this.emitShouldContinue(true);
                  }
                  this.appLoading = false;

                  const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                    height: 'auto',
                    width: '500px',
                    data: 'Hubo un cambio en los productos agregados, por favor revise antes de continuar',
                    disableClose: true,
                  });

                  dialogRef.afterClosed().subscribe(result => {
                    const currentRoute = this.router.url;
                    if(this.itineraryId) {
                       if (currentRoute !== `/itinerary-detail?id=${this.itineraryId}&stat=false&screen=detail`) {
                     this.router.navigateByUrl(`/itinerary-detail?id=${this.itineraryId}&stat=false&screen=detail`);
                    }
                    // console.log('result', result);
                    }
                  });

                }
              } else {

                if(data['mens'].some(c => c !== 'AV360')) {
                        const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                        height: 'auto',
                        width: '500px',
                        data: 'Hubo un cambio en los productos agregados, por favor revise antes de continuar',
                        disableClose: true,
                      });
                }
                  this.appLoading = false;
              }
            } else {
                  this.appLoading = false;
            }
        }, 750);
      } catch (error) {
        console.log(error);
        this.dialog.closeAll();
      }
    } else {
      const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
        height: 'auto',
        width: '400px',
        data: 'No existe productos para sincronizar',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result =>{
        // console.log('result', result);
      });
    }
  }


  updateItinerary() {
    this.appLoading = true;
    this.itemsArray = [];
    // amenitiesIncluded/addonsIncluded llegan inconsistentes según qué fetch pisó
    // this.itinerary último; se repone acá, justo antes de construir itemsArray,
    // que es el único lugar que realmente termina renderizándose.
    this.itineraryService.restoreVolatileItemFields(this.itinerary.items);
    this.itineraryService.captureVolatileItemFields(this.itinerary.items);

    this.itinerary.items.forEach((item: any, index: number) => {
      /// no actualiza por ser estatus difentes a saved
      this.statusArray.available = false;
      this.statusArray.samePrice = false;
      this.statusArray.modifications = false;
      this.statusArray.verified = false;
      this.noUpdatePrice(item);
      if (this.itemsArray.length === this.itinerary.items.length) {
        this.sortItemsByDestination();
      }
    });
  }

  noUpdatePrice(item: any) {
    this.itemsArray.push({
      arrayItem: null,
      item,
      result: null,
      available: this.statusArray.available, // false
      samePrice: this.statusArray.samePrice, // false
      price: item.totalPrice,
      modifications: this.statusArray.modifications, ///
      verified: this.statusArray.verified, // false
      dateTimeVerifed: moment(new Date(), 'YYYY-MM-DDTHH:mm'),
      reserved: this.statusArray.reserved,
      newNetPriceProvider: 0,
      newNetPriceUsblick: 0,
      newNetPriceAgent: 0,
      newBlickCoins: 0,
      roomAvailable: 0,
      expiration_date: item?.expiration_date,
    });

    // console.log("noUpdatePrice  this.itemsArray", this.itemsArray);
  }

  returnNetPrice(item): any {
    let price;
    switch (item.categoryName) {
      case 'HOTELS':
        price = item.optionNightsNetTotal;
        break;

      case 'TOURS':
        //     price = Number.parseInt(item.totalPrice);
        break;

      default:
        break;
    }

    return price;
  }

  sortItemsByDestination() {
    console.log(this.itinerary)
    console.log(this.itemsArray)
    this.destinationsArray = this.destinationPipe.transform(this.itinerary, this.itemsArray, this.datePipe);
    console.log(this.destinationsArray)
  }

  getDatesRange() {
    // const destination = this.itinerary.destination;
    // if (destination.length > 0) {
    //   const arrival = this.itinerary.arrivalDate
    //     ? this.datePipe.transform(this.itinerary.arrivalDate.toString(), "MMM dd, yyyy")
    //     : this.datePipe.transform(this.itinerary.arrivalDate.toString(), "MMM dd, yyyy");
    //   const departure =
    //     destination.length === 0 ? "" : " to " + this.datePipe.transform(this.itinerary.departureDate.toString(), "MMM dd, yyyy");
    //   return arrival + departure;
    // } else {
    //   return "Dates not defined";
    // }
  }

  deleteItem(id: string) {
  //  this.ngxSpinner.show();
  this.appLoading = true;
    this.destinationsArray.forEach((destination, index) => {
      destination.items.forEach((item, i) => {
        if (item.item.id === id) {
          this.destinationsArray[index].items.splice(i, 1);
          this.getDetailPricesCards();
        }
      });
      if (destination.items.length === 0) {
        this.destinationsArray.splice(index, 1);
      }
      this.appLoading = false;
      this.getItinerary(true);
    });

    if (this.destinationsArray.length == 0) {
      this.router.navigateByUrl('/home');
    }
  }

  cancelReservations(id: string) {
    // this.ngxSpinner.show();
    this.destinationsArray.forEach((destination, index) => {
      destination.items.forEach((item, i) => {
        if (item.item.id === id) {
          this.destinationsArray[index].items.splice(i, 1);
        }
      });
      if (destination.items.length === 0) {
        this.destinationsArray.splice(index, 1);
      }
    });


    //this.updateItinerary();
      this.getItinerary(false);
    ///this.ngxSpinner.hide();
      this.userService.updateProductsPrices(this.itinerary.id);
      this.ngxSpinner.hide();
  }

  save() {
    let goToURL: string;
    let navigationExtras: NavigationExtras;

    goToURL = 'DetailsSummaryItinerary';
    navigationExtras = {
      queryParams: {
        from: 'save-draft-reserve',
        itineraryId: this.itinerary.id,
      },
    };

    this.router.navigate([goToURL], navigationExtras);
  }



  reserve() {


    this.paymentAgencyActive;

    const transfersExists = this.itinerary.items.find(c => c.category_id === 8);
    const itemFlightMandatoryExists = this.itinerary.items.find(c =>
                                                                    c.category_id === 1 &&
                                                                    c.flightMandatory === true
                                                                    );

    if(transfersExists || itemFlightMandatoryExists) {

      if(this.validateCreateFly()) {
        this.itineraryService.updateParcialBlickoins(this.parcialBlickoins);
          this.updateCards(true, 'sync');
          let invalidOwner = false;
          this._cookieClient = this._cookieService.get('clientActive') != undefined ? this._cookieService.get('clientActive') : undefined;
          if (this._cookieClient !== undefined) {
            const data = this._cookieClient.split('||');
            if (data[2].trim() == '' || data[2].trim() == 'false' || data[4].trim() == '' || data[3].trim() == '') {
              invalidOwner = true;
            }
          }
      } else {

          this.openModalNewFly();
      }
    } else {

      this.itineraryService.updateParcialBlickoins(this.parcialBlickoins);
      this.updateCards(true, 'sync');
      let invalidOwner = false;
      this._cookieClient = this._cookieService.get('clientActive') != undefined ? this._cookieService.get('clientActive') : undefined;
      if (this._cookieClient !== undefined) {
        const data = this._cookieClient.split('||');
        if (data[2].trim() == '' || data[2].trim() == 'false' || data[4].trim() == '' || data[3].trim() == '') {
          invalidOwner = true;
        }
      }
    }

    // if (!invalidOwner) {
    //   let nr = false;
    //   this.userService.itineraryActive[0].items.forEach((element) => {
    //     console.log(element)
    //     switch(element.category_id) {
    //       case 1:
    //         if (element.room.rateClass === 'R') {
    //           this.openModalNR();
    //           nr = true;
    //           return;
    //         }
    //       case 8:
    //         if(element.pricing.rateClass === 'R') {
    //            this.openModalNR();
    //           nr = true;
    //           return;
    //         }
    //     }
    //   });
    //   if (nr) {
    //     return;
    //   }
    // }
  }


  onPartialSelection(event: {id: number; selected: boolean}) {
  if (event.selected) {
    this.partialSelectedItems.add(event.id);
  } else {
    this.partialSelectedItems.delete(event.id);
  }

}



  private validateCreateFly(): boolean {
      const fly = this.itinerary.flights?.[0] || this.itinerary.fly;

    if(this.isActivePartialReserve) {
        const hasNoTransportSelected = this.checkIfNoTransportSelected();

        if (hasNoTransportSelected) {
            return true; // Haces return aquí porque NO hay transports
          }
    }

      const transportItems = this.itinerary.items?.filter(c => c.category_id === 8) || [];
      const hotelItems = this.itinerary.items?.filter(c => c.category_id === 1) || [];

      // Si no hay transportes, validación exitosa
      if (transportItems.length === 0 && hotelItems.length === 0) {
          return true;
      }

      const flyNumberIn = fly?.flyNumberIn;
      const flyNumberOut = fly?.flyNumberOut;

      // Verificar cada item de transporte
      for (const item of transportItems) {
          const payload = item.payload?.[0];
          if (!payload?.transfers) {
continue;
}

          const { pickupLocation, dropoffLocation } = payload.transfers;

          if (pickupLocation?.type === 'airport' && !flyNumberIn) {

            this.payloadSearchTransportFly = item.payload;
            this.formTransportsFly = item.formTransport;
            this.notificationService.info('Como uno de los puntos del traslado es un aeropuerto, es necesario crear un vuelo para completar esta operación.');
            return false;
          }

          if (dropoffLocation?.type === 'airport' && !flyNumberOut) {
          this.payloadSearchTransportFly = item.payload;
          this.formTransportsFly = item.formTransport;
            this.notificationService.info('Como uno de los puntos del traslado es un aeropuerto, es necesario crear un vuelo para completar esta operación.');
              return false;
          }
      }


      for (const item of hotelItems) {

        if (item.flightMandatory) {


                  if (!flyNumberIn && !flyNumberOut) {
                    this.notificationService.info('Usted tiene un hotel agregado en el cual es necesario crear un vuelo para completar esta operación.');
                  return false;

              }

        }


      }

      return true;
  }


/**
 * Verifica si NO hay items de transporte O hoteles con flightMandatory en la selección
 */
private checkIfNoTransportSelected(): boolean {
  const selectedIds = Array.from(this.partialSelectedItems);
  const fly = this.itinerary.flights?.[0] || this.itinerary.fly;

  // Buscar si ALGÚN item seleccionado tiene category_id === 8 (transporte)
  // O category_id === 1 Y flightMandatory === true (hotel que requiere vuelo)
  const hasTransportOrMandatoryHotel = selectedIds.some(selectedId => {
    const item = this.itinerary.items.find(item => item.id === selectedId);

    if (!item) {
return false;
}

    // Es transporte
    if (item.category_id === 8) {

      const payload = item.payload?.[0];

      const { pickupLocation, dropoffLocation } = payload.transfers;

      if(pickupLocation?.type === 'airport' || dropoffLocation?.type === 'airport') {
        return true;
      } else {
        return false;
      }

    }

    // Es hotel con flightMandatory
    if (item.category_id === 1 && item.flightMandatory === true) {
      return true;
    }

    return false;
  });

  // Retorna true si NO hay transports NI hoteles con flightMandatory
  return !hasTransportOrMandatoryHotel;
}

  reserveAll() {
    const messageAlert = 'You cannot make a reservation of a product with changes, please solve your alerts or just select specific products.';
   /* if (this.status === "false") {
      this.updateCards();
      setTimeout(() => {}, 6000);
    }*/
    let ok = true;
    this.cardItinerary._results.forEach((card) => {
      if (card.item.modifications) {

        ok = false;
      }
    });
    if (ok) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          from: 'total-reserve',
          //'step': 'two',
          itineraryId: this.id,
        },
      };
      this.userService.stepReservation = 'two';
      this.userService.itineraryReserveId = this.id;
      // setTimeout(() => {
        this.router.navigate(['itinerary-reservation'], navigationExtras);
    //  }, 2000);
    } else {
      this.router.navigate(['/summary']);
    }
  }
  reserveItem(item: any) {
    this.partialReservationArray.push(item);
  }

  partialReserve() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        from: 'partial-reserve',
        step: 'two',
        itineraryId: this.id,
      },
    };
    // setTimeout(() => {
      this.router.navigate(['itinerary-reservation'], navigationExtras);
    // }, 2000);
  }
  /// Metodo para verificar si un room ha cambiado

  orderPriceLowHotel(data: any) {
    return data.sort(
      (a, b) =>
        Math.min.apply(
          null,
          a.additionalInfo.rooms
            .sort(function(a, b) {
              return a.netPriceProf - b.netPriceProf;
            })
            .map((resultObj) => resultObj.netPriceProf)
        ) -
        Math.min.apply(
          null,
          b.additionalInfo.rooms
            .sort(function(a, b) {
              return a.netPriceProf - b.netPriceProf;
            })
            .map((resultObj) => resultObj.netPriceProf)
        )
    );
  }

  getItemUpdated(item: any, data: any) {
    const itemArray = [];
    const modifications = false;
    let samePrice = false;
    let available = false;
    let verified = false;
    let roomAvailable = false;
    let newNetPriceProvider = 0;
    let newNetPriceUsblick = 0;
    let newNetPriceAgent = 0;
    let newBlickCoins = 0;
    let newCreditBlickoins = 0;
    let newBlickoinsFactor = 0;
    let newCreditFactor = 0;
    let newRoomType;
    let newPackageId;
    let newDescription;

    switch (item.categoryName) {
      case 'HOTELS':
        data.results.sort(
          (a, b) =>
            Math.min.apply(
              null,
              a.additionalInfo.rooms
                .sort(function(a, b) {
                  return a.netPriceProf - b.netPriceProf;
                })
                .map((resultObj) => resultObj.netPriceProf)
            ) -
            Math.min.apply(
              null,
              b.additionalInfo.rooms
                .sort(function(a, b) {
                  return a.netPriceProf - b.netPriceProf;
                })
                .map((resultObj) => resultObj.netPriceProf)
            )
        );
        if (data.results) {
          verified = true;
        }
        break;
      case 'TOURS':
        available = data.status ? true : false;
        newNetPriceProvider = item.netPriceProvider;
        if (available) {
          // eslint-disable-next-line max-len


          const _data = data.results[0] ? data.results[0].additionalInfo.tours.options : data.results.additionalInfo.tours.options;
          _data.forEach((option) => {
            if (item.optionId === option.optionId) {
              roomAvailable = true;
              samePrice = option.totalPrice == newNetPriceProvider ? true : false;
              if (!samePrice) {
                newNetPriceUsblick = option.totalPrice;
              }
            }
          });
          if (!roomAvailable) {
            newNetPriceUsblick = _data[0].totalPrice;
            newRoomType = _data[0].optionId;
          }
        }
        break;
      case 'PTHEMES':
        available = data.status ? true : false;
        newNetPriceProvider = item.optionTotal;
        if (available) {
          data.results[0].additionalInfo.options.forEach((option) => {
            if (option.name === item.name && option.description === item.description) {
              if (option.optionTotal === item.optionTotal) {
                samePrice = true;
              } else {
                newNetPriceUsblick = option.optionTotal;
              }
              roomAvailable = true;
            }
          });
          if (!roomAvailable) {
            newNetPriceUsblick = data.results[0].additionalInfo.options[0].optionTotal;
            newDescription = data.results[0].additionalInfo.options[0].description;
            newRoomType = data.results[0].additionalInfo.options[0].name;
          }
        }
        break;
      case 'INSURANCE':
        available = data.status ? true : false;
        newNetPriceProvider = item.totalPrice;
        if (available) {
          const results = data.results;
          results.forEach((result) => {
            if (result.title === item.title) {
              roomAvailable = true;
              if (result.additionalInfo.totalPrice === item.totalPrice) {
                samePrice = true;
              } else {
                newNetPriceUsblick = result.additionalInfo.totalPrice;
              }
            }
          });
          if (!roomAvailable) {
            newRoomType = data.results[0].title;
          }
        }
        break;
      case 'RENT-A-CAR':
        available = data.status ? true : false;
        newNetPriceProvider = item.totalPrice;
        roomAvailable = true;
        /* if (item.idProduct === data.results[0].productId) {

        }*/
        break;
      default:
        newNetPriceProvider = 0;
        newNetPriceUsblick = 0;
        newNetPriceAgent = 0;
        newBlickCoins = 0;
        newCreditBlickoins = 0;
        newBlickoinsFactor = 0;
        newCreditFactor = 0;
        available = false;
        samePrice = false;
        newDescription = '';
        newRoomType = '';
      break;
    }


    return {
      item,
      result: data,
      available,
      newPackageId,
      samePrice,
      modifications,
      verified,
      dateTimeVerifed: moment(new Date(), 'YYYY-MM-DDTHH:mm'),
      reserved: false,
      roomAvailable,
      newNetPriceProvider,
      newNetPriceUsblick,
      newNetPriceAgent,
      newBlickCoins,
      newCreditBlickoins,
      newBlickoinsFactor,
      newCreditFactor,
      newRoomType,
      newDescripton: newDescription,
    };
  }

  activePartial() {
    //siempre mandar a limpiar todos los items
    // this.itineraryService.updateRemoveItineraryPartial(this.id);
    if (this.isActivePartialReserve == true) {
      this.userService.isActivePartial = false;
      this.isActivePartialReserve = false;
      this.qtyItemsToPartial = 0;
      this.userService.totalPriceNotFeeByReserved = 0;
      this.userService.totalPriceYesFeeByReserved = 0;
      this.itineraryService.parcialBlickoins = 0;
    } else {
      this.isActivePartialReserve = true;
      this.userService.isActivePartial = true;
    }
  }

  _itemToPartial(qty) {
    this.qtyItemsToPartial = this.qtyItemsToPartial + qty;
  }

  openNR() {
    const dialogRef = this.dialog.open(NrPrepaymentModalComponent, {
      width: '820px',
      height: '700px',
      panelClass: 'background-modal',
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.reserveAll();
      } else {
      }
    });
  }

  openNRNotAvailable() {
    const dialogRef = this.dialog.open(NrBlockModalComponent, {
      width: '770px',
      height: '600px',
      panelClass: 'background-modal',
      //disableClose: true
    });
  }

  openModalNR() {
    let totalprice = 0;
    let totalpriceNR = 0;


    this.userService.itineraryActive[0].items.forEach((element) => {
      totalprice = totalprice + element.netPriceBooking;
      if (element.nr) {
        totalpriceNR = element.netPriceBooking + totalpriceNR;
      }
    });

    // console.log("total price all products", totalprice);
    // console.log("total price NR products", totalpriceNR);
    // console.log("this.fidelityService.creditPointActives", this.fidelityService.creditPointActives);
    // console.log("this.fidelityService.creditDepositActives", this.fidelityService.creditDepositActives);

    const agency = JSON.parse(localStorage.getItem('selectedAgency'));

    switch (agency.pay_mode) {
      case 1:
        if (this.fidelityService.creditPointActives >= totalpriceNR) {
          //si tengo para pagar con puntos
          this.openNR();
          break;
        } else {
          //si tengo para pagar con puntos
          //uso this.openNRNotAvailable();
          this.openNRNotAvailable();
          break;
        }

      case 2:
        this.openNR();
        break;

      case 3:
        if (
          this.fidelityService.creditPointActives >= totalpriceNR ||
          this.fidelityService.creditDepositActives >= totalpriceNR ||
          this.fidelityService.creditPointActives + this.fidelityService.creditDepositActives >= totalpriceNR
        ) {
          this.openNR();
        } else {
          this.openNRNotAvailable();
        }

        break;

      case 4:
        this.openNR();
        break;
      case 5:

        this.openNR();

        break;

      case 6:

        this.openNR();

        break;
      default:
        break;
    }
  }

  updateNRProduct(dato: any) {
    const date = dato.expirationDate ? moment(new Date()) : null;
    if (date) {
      if (date > moment(dato.expirationDate).subtract(2, 'days')) {
        this.itinerary.items.forEach((element) => {
          if (dato.id == element.id) {
            element.nr = true;
            this.itineraryService.updateItinerary(this.itinerary, false);
            return;
          }
        });
      }
    }
  }

  pay() {


    const dialogRef = this.dialog.open(ModalPostBookingComponent, {
      width: '899px',
      height: '80vh',
      data: {itinerary: this.itinerary, type: 'payment'},
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      //console.log('The dialog was closed', result);
      if (result) {
        this.itineraryService.consultActiveItinerary(this.userService._agentID, false, this.itinerary?.id, 'payment');
        this.getItinerary('false');
      } else {
        this.itineraryService.consultActiveItinerary(this.userService._agentID, false, this.itinerary?.id, 'payment');
        this.getItinerary('false');
      }
    });
  }

  searchProductReserved() {
    const result = this.itinerary.items.filter((element) => (element.status_id === 2 || element.status_id === 3) && element.source === 'Web');
    //console.log("existe items con status id 2 ", result);
    if (result.length > 0) {
      let i = 0;
      result.forEach((element) => {
        if (
          element.isPendigApprovePay === false &&
          element.isPaidAgency === false &&
          element.isPaidProvider === false &&
          element.isBilled === false
        ) {
          i++;
        }
      });

      if (i > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  _return(): void {
  }

  hasDisabledAlertMessage(): boolean {

  // const hasAlert = !this.isActivePartialReserve && this.qtyItemsToPartial === 0;

  // Verifica si TODOS los items cumplen al menos una condición de deshabilitación
  const allItemsHaveSomeDisablingCondition = this.itinerary.items.every(item => item.status_id === 5 ||
           item.status_id === 2 ||
           item.isPendigApprovePay ||
           item.isPaidAgency ||
           item.isPaidProvider);

    return allItemsHaveSomeDisablingCondition;

  }



getDateInOut(date: string): string {
  if (!date) {
return 'Fecha no válida';
}

  // Mapeo de meses inglés -> español
  const monthMap = {
    Jan: 'Ene', Feb: 'Feb', Mar: 'Mar',
    Apr: 'Abr', May: 'May', Jun: 'Jun',
    Jul: 'Jul', Aug: 'Ago', Sep: 'Sep',
    Oct: 'Oct', Nov: 'Nov', Dec: 'Dic'
  };

  // Reemplazar el mes inglés por español
  const englishMonth = date.substring(0, 3);
  const spanishDate = monthMap[englishMonth] + date.substring(3);

  moment.locale('es');
  const parsedDate = moment(spanishDate, 'MMM DD, YYYY', 'es', true);

  if (!parsedDate.isValid()) {
    console.error('Fecha inválida:', date);
    return 'Fecha inválida';
  }

  return parsedDate.format('MMM DD, YYYY'); // Salida en español
}

  private getTransportFlightContext(): { payloadSearch: any; formTransports: any } | null {
    const transportItems = this.itinerary?.items?.filter(item => item.category_id === 8) || [];
    if (transportItems.length === 0) {
return null;
}

    const fly = this.itinerary?.flights?.[0] || this.itinerary?.fly;
    const missingFlightItem = transportItems.find(item => {
      const transfers = item.payload?.[0]?.transfers;
      return transfers && (
        (transfers.pickupLocation?.type === 'airport' && !fly?.flyNumberIn) ||
        (transfers.dropoffLocation?.type === 'airport' && !fly?.flyNumberOut)
      );
    });

    const item = missingFlightItem || transportItems.find(item => item.payload?.[0]?.transfers);
    return item ? { payloadSearch: item.payload, formTransports: item.formTransport } : null;
  }

  private setTransportFlightContext(): void {
    const context = this.getTransportFlightContext();
    this.payloadSearchTransportFly = context?.payloadSearch;
    this.formTransportsFly = context?.formTransports;
  }

openModalNewFly(): void {
  this.setTransportFlightContext();
  this.openModalFly = true;
  this.actionComponentFlight = 'new';
}

onFlightModalClosed(): void {
  this.openModalFly = false;
}

updateFly(event: boolean): void {

  // Ocultar componente
  this.openModalFly = false;

  this.getItinerary('false');
  this.getDetailPricesCards();
  this.userService.activeGlobalFee = false;
  this.verificarCondiciones();
  this.partialSelectedItems.clear();
}


loadingCancelSplash(event: any){
  this.appLoading = event;
}

 globalFeeUnavaibleWithAmount(): void {

}

  public formatIata(iata: string): string {
    if (!iata) {
      return iata;
    }
    return iata.slice(0, 3).toUpperCase();
  }

}
